import EntryRacikanForm from "./EntryRacikanForm";

const TambahEntryRacikan = () => <EntryRacikanForm />;

export default TambahEntryRacikan;
